import React from 'react';
import PropTypes from 'prop-types';
import AuthContext from './Provider';
import ProtectedItemWithAuth from './ProtectedItemWithAuth';

const ProtectedItem = props => (
  <AuthContext.Consumer>
    {auth => (
      <ProtectedItemWithAuth auth={auth} {...props} />
    )}
  </AuthContext.Consumer>
);

export default ProtectedItem;

ProtectedItem.defaultProps = {
  allowedPermissions: [],
};

ProtectedItem.propTypes = {
  allowedPermissions: PropTypes.arrayOf(PropTypes.string),
};



// WEBPACK FOOTER //
// ./src/components/ComponentesAutenticacao/ProtectedItem.jsx